import { iife, Maybe } from '@crocodille/common';
import { useTranslation } from 'react-i18next';
import Image from '../../elements/image/image';
import { useRouter } from 'next/router';
import React from 'react';
import styles from './product-out-of-stock.module.scss';
import { useMedia } from '../../../hooks/use-media';

import outOfStockImage from '../../../../public/out-of-stock/out_of_stock.png';
import outOfStockEnImage from '../../../../public/out-of-stock/out_of_stock-en.png';
import outOfStockMobileImage from '../../../../public/out-of-stock/out_of_stock-mobile.png';
import outOfStockMobileEnImage from '../../../../public/out-of-stock/out_of_stock-mobile-en.png';

export interface ProductOutOfStockProps {
  readonly isAvailable?: Maybe<boolean>;
  readonly forceMobile?: boolean;
}

/**
 * A card displaying product information in product listing.
 */
const ProductOutOfStock: React.FC<
  React.PropsWithChildren<ProductOutOfStockProps>
> = ({ isAvailable = false, forceMobile = false }) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  const isMobile = useMedia('layout-with-drawer', false);

  const outOfStockImg = iife(() => {
    if (isMobile || forceMobile) {
      if (locale === 'cs') {
        return outOfStockMobileImage;
      } else {
        return outOfStockMobileEnImage;
      }
    } else {
      if (locale === 'cs') {
        return outOfStockImage;
      } else {
        return outOfStockEnImage;
      }
    }
  });

  return !isAvailable ? (
    <div className={styles.imageContainer}>
      <Image
        className={styles.image}
        src={outOfStockImg}
        alt={t('cart.out_of_stock')}
        layout="fill"
      ></Image>
    </div>
  ) : null;
};

export default ProductOutOfStock;
